import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcUserAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 3a8 8 0 1 1 0 16c-6.686 0-9.89 2.81-9.997 8.693L6 28H4c0-5.66 2.526-9.193 7.386-10.465A8 8 0 0 1 16 3Zm11 19a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3ZM16 5a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgIcUserAdd;